import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";

interface Props {
  color?:
    | "accent"
    | "success"
    | "warning"
    | "green"
    | "blue"
    | "darkGray"
    | "lightGray"
    | "black"
    | "error";
  shape?: "round" | "arrow" | "roundSmall";
  type?: "default" | "inline";
}

const Tag: React.FC<Props> = (props) => {
  const { children, color, shape, type = "default" } = props;

  const className = classNames(
    styles.main,
    shape && styles[shape],
    color && styles[color],
    styles[type],
  );

  return <span className={className}>{children}</span>;
};

export { Tag };
